import { useGateValue, useLayer } from '@coursera-web/statsig';

import {
  EDIT_GOAL_ENABLED_URL,
  EDIT_GOAL_REDIRECT_LAYER,
  EDIT_GOAL_REDIRECT_URL,
  PERSONALIZATION_SETTINGS_GATE,
} from 'bundles/personalization-settings/constants';

/**
 * Whether the Personalization settings tab is enabled for the current user.
 *
 * Wraps the `personalised_settings_page` Statsig gate so consumers (the
 * account-settings mount site) call a named, unit-tested bundle hook rather
 * than `useGateValue` directly. Dark-launched — the gate defaults OFF until
 * rollout.
 */
export const useIsPersonalizationSettingsEnabled = (): boolean => useGateValue(PERSONALIZATION_SETTINGS_GATE);

/**
 * Whether the edit goal redirect is for onboarding or to personalization settings
 */
export const useIsEditGoalRedirectEnabled = (): boolean => {
  const layer = useLayer(EDIT_GOAL_REDIRECT_LAYER);

  const editGoalUrl = layer.get(EDIT_GOAL_REDIRECT_URL, 'onboarding');

  return editGoalUrl === EDIT_GOAL_ENABLED_URL;
};
